import { getVybeToken } from "@/lib/vybe-auth";
import { Gateway } from "./types";

/** Resolve the CRM base URL the same way the hub URL is resolved (Vite env, with SSR fallback). */
function readCrmUrl(): string {
  const viteUrl = import.meta.env.VITE_CRM_URL;
  if (viteUrl) return viteUrl;
  if (typeof process !== "undefined" && process.env) {
    return process.env.VITE_CRM_URL || process.env.NEXT_PUBLIC_CRM_URL || "";
  }
  return "";
}

/** Fetch the public gateway topology (name, hub URL, broker servers) from the CRM. */
export async function fetchGateways(): Promise<Gateway[]> {
  const base = readCrmUrl();
  if (!base) return [];
  // Attach the Vybe bearer token so the CRM can resolve the caller's plan and filter the catalog
  // server-side. A signed-out visitor sends no token and is treated as the Anonymous floor.
  const token = getVybeToken();
  const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
  const res = await fetch(`${base.replace(/\/$/, "")}/api/gateways`, { headers });
  if (!res.ok) {
    throw new Error(`Failed to fetch gateways (${res.status})`);
  }
  return (await res.json()) as Gateway[];
}
